/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_appsync_graphqlEndpoint": "https://qxqrrywe3bawlig5n7kctf47xu.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "AWS_IAM",
    "aws_cognito_identity_pool_id": "ap-south-1:b84ec039-9970-4a12-adde-c48f18705a31",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_iBNTX19ou",
    "aws_user_pools_web_client_id": "27o8knm2kssq23a7k52cacff7d",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "vidhifarm-storage-219dfeef04fa1-main",
    "aws_user_files_s3_bucket_region": "ap-south-1"
};


export default awsmobile;
